@let positionDataValue = positionData();

<div class="header-container">
  <div class="header-info">
    <div class="icon-container">
      <rt-icon name="positions" size="medium" colorToken="colorIconPrimaryDefault" />
    </div>
    <div class="header-text">
      <span class="position-label">{{
        'tlc.positions.position_details_dialog.header' | translate
      }}</span>
      <span class="position-name">{{ positionDataValue?.name }}</span>
    </div>
    <rt-icon-button iconName="more-horiz" variant="tertiary" />
  </div>
  <rt-tabs class="tabs-container">
    <rt-tab class="active"
      >{{ 'tlc.positions.position_details_dialog.tabs.employees.label' | translate }}
    </rt-tab>
    <rt-tab>{{ 'tlc.positions.position_details_dialog.tabs.description' | translate }}</rt-tab>
    <rt-tab>{{ 'tlc.positions.position_details_dialog.tabs.skills' | translate }}</rt-tab>
  </rt-tabs>
</div>
<rt-dialog-body variant="white">
  <div class="empty-state-container">
    <rt-empty-state
      icon="positions"
      [title]="'tlc.positions.position_details_dialog.tabs.employees.empty_state.title' | translate"
      [desc]="'tlc.positions.position_details_dialog.tabs.employees.empty_state.desc' | translate"
    >
      <rt-button variant="primary">
        <rt-icon name="add" />
        <span>{{
          'tlc.positions.position_details_dialog.tabs.employees.empty_state.cta_button' | translate
        }}</span>
      </rt-button>
    </rt-empty-state>
  </div>
</rt-dialog-body>
